<template>
  <Div class="information">
    <MyTransition :myName="'up'">
      <Popup v-if="popupStatus">
        <PopupText
          v-if="popup=='text'"
          :title="popup_title"
          :text="successText"
          @check="poupupEnter"
        >
          <Div class="notice_file_dow flex">
            <div v-for="(item,index) in popup_fileList" :key="index">
              <a :href="`${storage}${item.file}`" target="_blank">
                <button class="btn_border_black">{{item.file.split("/")[1]}}</button>
              </a>
            </div>
          </Div>
        </PopupText>
        <PopupSuccess v-if="popup=='success'" :text="successText" @check="poupupEnter"></PopupSuccess>
        <PopupError v-if="popup=='error'" :text="successText" @check="poupupEnter"></PopupError>
      </Popup>
    </MyTransition>


      <div class="login_information white">
        <H2>最新公告</H2>
        <!-- 置頂 -->
        <div class="is_sticky">
          <template v-for="(item,index) in notice_list">
            <div
              class="notice_list flex"
              v-if="item.is_sticky"
              :key="index"
              @click="noticeDetialed(item,index)"
            >
              <div class="notice_item">{{item.title}}</div>
              <div class="notice_time">{{item.start_date}}</div>
            </div>
          </template>
        </div>

        <!-- 一般 -->
        <template v-for="(item,index) in notice_list">
          <div
            class="notice_list flex"
            v-if="!item.is_sticky"
            :key="index"
            @click="noticeDetialed(item,index)"
          >
            <div class="notice_item">{{item.title}}</div>
            <div class="notice_time">{{item.start_date}}</div>
          </div>
        </template>
      </div>



  </Div>
</template>
<style lang="scss">
.information {
  width: 100%;
}
.pink {
  background: #f3adad;
  h1 {
    color: #fff;
  }
}
.white {
  background: #fff;
  h1 {
    color: var(--mainColorHover);
  }
}
.login_information {
  margin: 0px 10px 30px 10px;
  text-align: left;
  width: 100%;
  padding: 30px;
  border-radius: 8px;
  h1 {
    font-size: 25px;

    font-weight: bold;
  }
  h2 {
    font-weight: bold;
    margin-bottom: 15px;
  }

  .is_sticky {
    background: #e8e9f1;
    padding: 0 10px;
    .notice_list {
    }
  }

  .notice_list {
    cursor: pointer;
    border-bottom: 1px solid #e4e4e4;
    margin: 5px 0;
    padding: 10px 0;
    justify-content: space-between;
    &:hover {
      color: var(--mainColor);
    }
    &:last-child {
      border-bottom: none;
    }
  }
  .notice_more {
    justify-content: flex-end;
    .btn_gray {
      width: 80px;
      font-size: 12px;
    }
  }

  .block {
    padding-top: 10px;
    margin-top: 10px;
    color: #fff;
    border-top: 1px dashed #fff;
    font-size: 15px;
    h2 {
      padding: 5px 20px;
      background: #fff;
      width: fit-content;
      color: #fa9090;
    }
  }
}
.information_block {
  display: flex;
}
.notice_file_dow {
  flex-wrap: wrap;
  button {
    margin: 5px;
    padding: 3px 8px;
    border-radius: 3px;
    font-size: 12px;
    width: fit-content;
  }
}
</style>
<script>
export default {
  name: "information",
  data() {
    return {
      notice_list: [],
      popupStatus: false,
      successText: null,
      popup: null,
      popup_title: null,
      popup_fileList: []
    };
  },
  computed: {
    storage() {
      return this.$http.base.storage;
    }
  },
  created() {
    this.getNotice();
  },
  methods: {
    getNotice() {
      this.$http.api.admin.announcementGet().then(res => {
        this.notice_list = res.data;
      });
    },
    noticeDetialed(item, index) {
      this.$http.api.admin.announcementGet(item.announcement_id).then(res => {
        this.popupStatus = true;
        this.popup = "text";
        this.popup_title = res.data[0].title;
        this.successText = `
          ${res.data[0].content}
        `;
        this.popup_fileList = res.data[0].attachment;
      });
    },
    poupupEnter() {
      this.popupStatus = false;
    }
  }
};
</script>